<template>
  <v-form ref="changePasswordForm" lazy-validation v-click-outside="cancel" class="changePassword">
    <v-layout row wrap>
      <v-flex class="alert__box__success" v-if="success">
        <v-icon>check</v-icon>
        {{ myAccountConstants.passwordConstants.PASSWORD_CHANGE_SUCCESS }}
      </v-flex>
      <v-flex class="changePassword__error" v-if="errorMessage" mt-2 mb-2>
        <v-layout row>
          <v-flex class="changePassword__error--message">{{ errorMessage }}</v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout column wrap>
      <v-flex xs12 mt-2 mb-1>
        <div class="password-label">
          {{ myAccountConstants.passwordConstants.CURRENT_PASSWORD }}
        </div>
        <v-text-field
            id="currentPassword_input"
            data-qe-id="currentPassword_input"
            name="currentPassword"
            class="current-password"
            autocomplete="off"
            :type="showCurrentPassword ? 'text' : 'password'"
            v-model="currentPassword"
            :disabled="isSubmitting"
            required
            @focus="resetError"
            :append-icon="showCurrentPassword ? 'visibility' : 'visibility_off'"
            @click:append="showCurrentPassword = !showCurrentPassword"></v-text-field>
      </v-flex>
      <v-flex>
        <div class="password-label">{{ myAccountConstants.passwordConstants.NEW_PASSWORD }}</div>
        <v-text-field
            id="newPassword_input"
            data-qe-id="newPassword_input"
            name="newPassword"
            class="new-password"
            autocomplete="off"
            :type="showNewPassword ? 'text' : 'password'"
            v-model="newPassword"
            :disabled="isSubmitting"
            required
            @focus="resetError"
            :append-icon="showNewPassword ? 'visibility' : 'visibility_off'"
            @click:append="showNewPassword = !showNewPassword"></v-text-field>
      </v-flex>
    </v-layout>
    <v-flex xs-12 v-if="passwordRequirementList">
      <v-layout column wrap class="password-complexity">
        <v-flex class="password-complexity__title">{{ loginSecurityConstants.PASSWORD_CHANGE_INTRO_LABEL }}</v-flex>
        <v-flex pt-1>
          <ul class="password-complexity__list">
            <li class="password-complexity__list-item"
                v-for="passRequirement in passwordRequirementList" :key="passRequirement.key">
              {{ passRequirement.label }}
            </li>
          </ul>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 mt-4 mb-3>
      <v-layout row wrap>
        <div class="password-label">{{ myAccountConstants.passwordConstants.CONFIRM_NEW_PASSWORD }}</div>
        <v-text-field
            id="confirm_newpassword_input"
            data-qe-id="confirm_newpassword_input"
            name="confirmNewPassword"
            class="new-password"
            autocomplete="off"
            :type="showConfirmNewPassword ? 'text' : 'password'"
            v-model="confirmNewPassword"
            :disabled="isSubmitting"
            required
            :append-icon="showConfirmNewPassword ? 'visibility' : 'visibility_off'"
            @click:append="showConfirmNewPassword = !showConfirmNewPassword"></v-text-field>
      </v-layout>
    </v-flex>
    <v-flex class="action__btn">
      <v-btn class="primary_btn transparent small" id="cancel_btn_password" @click="cancel()"
             data-qe-id="changePassword_cancelBtn">
        {{ myAccountConstants.CANCEL }}
      </v-btn>
      <v-btn
          id="submit_password_change_btn"
          data-qe-id="submit_password_change_btn"
          :class="['primary_btn small']"
          :disabled="!isSaveEnabled"
          @click="submit">
        {{ myAccountConstants.SAVE }}
      </v-btn>
    </v-flex>
  </v-form>
</template>

<script>
import { loginSecurityConstants, myAccountConstants } from "../MyAccount/myaccount.constants.js";
import { mapActions, mapGetters } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import ClickOutside from "vue-click-outside";

export default {
  name: "ChangePassword",
  data: () => ({
    myAccountConstants,
    loginSecurityConstants,
    showCurrentPassword: false,
    showNewPassword: false,
    showConfirmNewPassword: false,
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    success: false,
    isSubmitting: false,
    postBody: {
      oldPassword: null,
      newPassword: null,
    },
    errorMessage: null,
  }),
  methods: {
    cancel() {
      this.emptyFields();
      this.resetError();
      this.showCurrentPassword = false;
      this.showNewPassword = false;
      this.showConfirmNewPassword = false;
    },
    emptyFields() {
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmNewPassword = "";
    },
    resetError() {
      this.success = false;
      this.errorMessage = null;
    },
    submit() {
      this.isSubmitting = true;
      this.resetError();
      this.postBody.oldPassword = this.currentPassword;
      this.postBody.newPassword = this.newPassword;
      this.changePassword(this.postBody)
          .then(() => {
            this.success = true;
            this.emptyFields();
            this.isSubmitting = false;
            document.getElementById("MyAccountMenu").scrollTop = 0;
          })
          .catch(() => {
            const myAccountMenu = document.getElementById("MyAccountMenu");
            if (myAccountMenu) {
              myAccountMenu.scrollTop = 0;
            }
            this.errorMessage = this.passwordResponse.message 
                ? this.passwordResponse.message 
                : myAccountConstants.passwordConstants.PASSWORD_WARNING;
            this.isSubmitting = false;
          });
    },
    ...mapActions({
      changePassword: `myAccount/${storeAction.changePassword}`,
    }),
    whenClosed() {
      this.cancel();
    },
  },
  props: {
    registerOnClose: {
      type: Function,
      required: true,
    },
  },
  created() {
    this.registerOnClose(() => this.whenClosed());
  },
  computed: {
    isSaveEnabled() {
      return !this.isSubmitting && this.currentPassword.length
          && this.newPassword.length
          && this.confirmNewPassword.length
          && this.newPassword === this.confirmNewPassword
          && this.currentPassword !== this.newPassword;
    },
    ...mapGetters({
      profileInformation: `myAccount/${storeGetters.profileInformation}`,
      passwordResponse: `myAccount/${storeGetters.passwordResponse}`,
      passwordComplexityRequirements: `manageLoginSecurity/${storeGetters.passwordComplexityRequirements}`,
    }),
    passwordRequirementList() {
      return this.passwordComplexityRequirements && this.passwordComplexityRequirements.length ? this.passwordComplexityRequirements : null
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
.changePassword {
  &__error {
    background-color: $ypo-error-red;
    padding: 5px;
    &--message {
      color: $white;
      font-weight: 500;
      font-size: 13px;
      padding-left: 10px;
    }
  }

  .current-password {
    cursor: text;
    box-sizing: border-box;
    padding: 0px;
  }

  .password-label {
    font-weight: bold;
    color: $ypo-cta;
    font-family: "Noto Sans", Sans-Serif;
    font-size: 12px;
  }

  .action__btn {
    border-bottom: 1px solid rgba($ypo-cta, 0.2);
    flex: auto;
    width: auto;
    max-width: initial;
    text-align: right;
    padding: 10px;
    margin: 0 -30px;

    .v-btn {
      margin: 0 0 0 10px !important;
      height: 30px !important;
    }
  }

  .match-active {
    color: $ypo-green;
  }

  .match-inactive {
    color: $ypo-gray;
  }

  .partially-active {
    color: $ypo-gold;
  }

  .alert__box {
    &__success {
      background: $ypo-gold;
      color: $white;
      padding: 10px 10px 10px 10px;
      font-size: 12px;
      text-transform: initial;
      line-height: normal;
      margin-bottom: 15px;

      i {
        font-size: 20px !important;
        color: $white !important;
        opacity: 1 !important;
        left: 5px;
        top: 0;
        bottom: 0;
      }
    }
  }

  .new-password {
    padding-top: 0px;
  }

  .password-complexity {
    padding-left: 10px;
    &__title {
      font-size: 12px;
      color: $ypo-blue;
    }
    &__list {
      list-style-type: disc;
      font-size: 11px;
      color: $ypo-blue;
    }
  }
}

</style>
